import React, { useState } from 'react';
import axios from 'axios';

export default function EnrollStep({ ocrData, onBack, onContinue, isAlreadyEnrolled = false, signalInfo: presetSignal }) {
  const [status, setStatus] = useState('idle'); // 'idle' | 'saving' | 'success' | 'error'
  const [error, setError] = useState('');
  const [signalInfo, setSignalInfo] = useState(null);

  const signalColors = {
  strong: 'text-green-600',
  weak: 'text-yellow-500',
  none: 'text-red-600',
};

  const handleEnroll = async () => {
    setStatus('saving');
    setError('');
    setSignalInfo(null);

    try {
      const res = await axios.post('http://localhost:4000/api/enroll-device', ocrData);

      if (res.data.alreadyEnrolled) {
      setStatus('already');
      setSignalInfo(res.data.device);
      return;
    }

      if (res.data.success) {
        setSignalInfo(res.data);
        setStatus('success');
      } else {
        throw new Error('Backend returned unsuccessful response');
      }
    } catch (err) {
      console.error(err);
      setError('Enrollment failed. Please try again.');
      setStatus('error');
    }
  };

  const handleContinue = () => {
    onContinue(signalInfo); // pass signal info to next step
  };

  if (isAlreadyEnrolled && presetSignal) {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Device Already Enrolled</h2>
      <div className="bg-yellow-50 border border-yellow-300 p-4 rounded-md mb-6 text-sm text-gray-800">
        <p><strong>Serial:</strong> {ocrData.serialNumber}</p>
        <p><strong>EUI:</strong> {ocrData.eui}</p>
        <p><strong>Signal:</strong> {presetSignal.status}</p>
        <p><strong>RSSI:</strong> {presetSignal.rssi}</p>
        <p><strong>SNR:</strong> {presetSignal.snr}</p>
      </div>
      <div className="flex justify-between">
        <button onClick={onBack} className="text-primary text-sm hover:underline">← Back</button>
        <button
          onClick={() => onContinue(presetSignal)}
          className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition"
        >
          Continue to Commission
        </button>
      </div>
    </div>
  );
}

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Step 3: Enroll Device</h2>

      <div className="bg-gray-50 border rounded-lg p-4 mb-4 text-sm text-gray-700">
        <p><strong>Serial:</strong> {ocrData.serialNumber}</p>
        <p><strong>EUI:</strong> {ocrData.eui}</p>
      </div>

      {status === 'success' && signalInfo && (
        <div className="bg-green-50 border border-green-300 p-4 rounded-md mb-4 text-sm text-green-800">
          ✅ Device enrolled successfully!
            <p><strong>Signal:</strong> <div className={`flex items-center gap-2 font-medium ${signalColors[signalInfo.signalStrength]}`}>
          ● {signalInfo.status}</div></p>
            <p><strong>RSSI:</strong> {signalInfo.rssi} dBm</p>
            <p><strong>SNR:</strong> {signalInfo.snr} dB</p>
          </div>
      )}

      {status === 'already' && signalInfo && (
        <div className="bg-yellow-50 text-yellow-800 border border-yellow-300 p-4 rounded-md mb-4 text-sm">
            ⚠️ This device is already enrolled.
            <div className="mt-2 text-gray-700">
            <p><strong>Serial:</strong> {signalInfo.serialNumber}</p>
            <p><strong>EUI:</strong> {signalInfo.eui}</p>
            <p><strong>Type:</strong> {signalInfo.deviceType}</p>
            </div>
        </div>
        )}

      {status === 'error' && (
        <div className="text-sm text-red-500 mb-4">{error}</div>
      )}

      <div className="flex justify-between">
        <button onClick={onBack} className="text-primary text-sm hover:underline">← Back</button>

        {status === 'success' ? (
          <button
            onClick={handleContinue}
            className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition"
          >
            Continue to Commission
          </button>
        ) : (
          <button
            onClick={handleEnroll}
            disabled={status === 'saving'}
            className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition disabled:opacity-60"
          >
            {status === 'saving' ? 'Enrolling...' : 'Enroll Device'}
          </button>
        )}
      </div>
    </div>
  );
}
